export default "__VITE_ASSET__BvPkXYcT__"